export default __webpack_public_path__ + "static/media/tPro2.7e6ba299.jpg";